module.exports = __webpack_public_path__ + "img/7.6762d6b3.png";